import { render, staticRenderFns } from "./DocumentsSingle.vue?vue&type=template&id=7daf09da&scoped=true"
import script from "./DocumentsSingle.vue?vue&type=script&lang=js"
export * from "./DocumentsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf09da",
  null
  
)

export default component.exports